<main class="flex-col flex-align-center-center" [class]="prod ? 'app-login-container' : 'app-login-container-devel'">
  <h1 class="cdk-visually-hidden">Registrul Medicilor, autentificare</h1>
  <div class="app-login-main mat-elevation-z12">
    <mat-card appearance="outlined">
      <mat-card-title>
        @if (!prod) {
          <span>Site Test - C.M.R.</span>
        }
        @if (prod) {
          <span>Colegiul Medicilor din România</span>
        }
      </mat-card-title>
      <mat-card-content>
        <form class="flex-col flex-gap-10" novalidate (keyup.enter)="onLogin()">

          <mat-form-field class="display-block"><mat-label>email</mat-label>
          <input autofocus matInput [formField]="userForm.email" type="text" autocomplete="username">
          <mat-error>Adresa de email este invalidă</mat-error>
        </mat-form-field>

        <mat-form-field class="display-block"><mat-label>password</mat-label>
        <input matInput [formField]="userForm.password" [type]="show() ? 'text' : 'password'" autocomplete="current-password"
          #inputFocus>
        <button type="button" matSuffix mat-icon-button aria-label="Arată parola" [attr.aria-pressed]="show()" (click)="toggleShow()">
          <mat-icon>{{ show() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error>Parola este invalidă</mat-error>
      </mat-form-field>

    </form>
  </mat-card-content>

  <mat-card-actions class="flex-align-center">
    <button [disabled]="userForm().invalid() || isLoading()" type="submit" mat-button color="primary" (click)="onLogin()">Autentificare</button>
  </mat-card-actions>
</mat-card>
</div>
</main>